import { Component, OnInit } from '@angular/core';
import { SocketService } from 'src/services/socket.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone:false
})
export class AppComponent implements OnInit {
  constructor(
    private socketService: SocketService,
  ) { }

  ngOnInit(): void {
    // Keep the root socket service alive so session invalidation events
    // can log out the previous device immediately when available.
    void this.socketService;
  }
}
